{
    "age_verification": {
        "title": "Velkommen!",
        "message": "Er du {{minAge}} år gammel eller ældre?",
        "button": "Gå ind",
        "error_message": "Du skal være {{minAge}} år gammel eller ældre for at se dette indhold.",
        "button_reset": "Tilbage"
    },

    "welcome": {
        "title": "Velkommen!",
        "description": ""
    },

    "unknown": {
        "title": "Ukendt side",
        "description": "Den side, du prøver at nå, findes ikke eller er ikke tilgængelig."
    },

    "preview": {
        "text": "Dette er en forhåndsvisning og er kun midlertidigt tilgængelig."
    },

    "cookies": {
        "title": "Cookies",
        "description": "Denne hjemmeside bruger cookies til at forbedre brugeroplevelsen. Ved at fortsætte accepterer du vores cookiepolitik.",
        "button_accept_all": "Acceptér alle",
        "button_decline_all": "Afvis alle",
        "button_show_preferences": "Vis præferencer",
        "button_save_preferences": "Gem præferencer",
        "button_close": "Luk",

        "sections": {
            "introduction": {
                "title": "Præference-menu",
                "description": "Denne hjemmeside bruger cookies til at forbedre brugeroplevelsen. Cookies er små tekstfiler, der gemmes på din enhed, når du besøger vores hjemmeside. De hjælper os med at forstå, hvordan du bruger siden, og gør det muligt for os at forbedre funktionalitet og ydeevne."
            },

            "information": {
                "title": "Mere information",
                "description": "Har du spørgsmål om vores cookiepolitik og dine valg, <a href=\"#contact-page\">kontakt os venligst</a>."
            },

            "necessary": {
                "title": "Nødvendige",
                "description": "Disse cookies er essentielle for, at hjemmesiden fungerer, og kan ikke deaktiveres i vores systemer. De bliver som regel kun sat som reaktion på handlinger, du har foretaget, f.eks. indstilling af din alder."
            },
            "analytics": {
                "title": "Analyser",
                "description": "Disse cookies hjælper os med at forstå, hvordan besøgende bruger vores hjemmeside, ved at indsamle anonym information og generere rapporter. De kan bruges til at forbedre websitets ydeevne og forstå, hvilke sider der er populære, samt hvordan besøgende navigerer på siden."
            }
        }
    }
}